import { FC, PropsWithChildren } from 'react';
import { cn, SCROLL_AREA_VIEWPORT_BLOCK } from '@/shared/lib';
import { ScrollArea } from '@ibsys/kit';

/**
 * Внутренний контейнер вьюпорта `ScrollArea` — колонка не ниже самой области. Ширину содержимого,
 * как и {@link SCROLL_AREA_VIEWPORT_BLOCK}, ограничивает область.
 */
const SCROLL_AREA_VIEWPORT_FULL_HEIGHT =
  '[&>[data-radix-scroll-area-viewport]>div]:!flex [&>[data-radix-scroll-area-viewport]>div]:flex-col [&>[data-radix-scroll-area-viewport]>div]:min-h-full';

type Props = PropsWithChildren<{
  className?: string;
  outerClassName?: string;
  enableScroll?: boolean;
  limitedWidth?: boolean;
  /**
   * Содержимое прокручиваемой страницы не ниже её высоты: блок, растущий в остаток высоты, заполняет
   * экран, а не поместившееся содержимое прокручивается вместе со страницей
   */
  isFullHeight?: boolean;
}>;

/** Контейнер содержимого страницы: отступы, ограничение ширины и прокрутка страницы */
export const PageContainer: FC<Props> = ({
  className,
  children,
  outerClassName,
  enableScroll = true,
  limitedWidth = true,
  isFullHeight = false,
}) => {
  const content = (
    <div className={cn('p-2 md:p-8 flex flex-col w-full h-full', isFullHeight && 'flex-1', outerClassName)}>
      <div className={cn(limitedWidth && 'max-w-7xl mx-auto w-full', 'h-full', isFullHeight && 'flex-1', className)}>
        {children}
      </div>
    </div>
  );

  if (!enableScroll) {
    return content;
  }

  return (
    <ScrollArea className={cn('h-full', isFullHeight ? SCROLL_AREA_VIEWPORT_FULL_HEIGHT : SCROLL_AREA_VIEWPORT_BLOCK)}>
      {content}
    </ScrollArea>
  );
};
